import Button from "devextreme-react/button";
import Popup, { ToolbarItem } from "devextreme-react/popup";
import TextArea from "devextreme-react/text-area";
import Validator, { RequiredRule } from "devextreme-react/validator";
import { useContext, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { LoadPopupPanel } from "../../../../components";
import { Field } from "../../../../layouts";
import { AR } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useRejectCancellation } from "../api/reject-cancellation";
import { PurchaseOrderContext } from "../context/PurchaseOrderContext";

export default function RejectCancellationButton() {

	const { order, refetchOrder } = useContext(PurchaseOrderContext);

	const [searchParams, setSearchParams] = useSearchParams();
	let isReject = searchParams.get("Cancel") === "0";

	const [isPopupVisible, setPopupVisibility] = useState(false);
	const reasonRef = useRef<TextArea>(null);

	const rejectCancellation = useRejectCancellation(order.details.purchaseOrderID,
		() => {
			if (searchParams.has('Cancel')) {
				searchParams.delete('Cancel');
				setSearchParams(searchParams);
			}

			showSuccessMessage('Cancellation has been rejected');
			refetchOrder();
			setPopupVisibility(false);
		},
		(error) => showErrorMessage(error));

	useEffect(() => {
		if (isReject) {
			if (!order.details.activeARs.includes(AR.PODistributorToApproveCancelation)) {
				searchParams.delete('Cancel');
				setSearchParams(searchParams);
				showErrorMessage("The order is not pending cancellation");
			}
			else {
				setPopupVisibility(true);
			}
		}
	}, [isReject]);

	return (
		<>
			<Button elementAttr={{ 'data-testid': 'btn-reject-cancellation' }}
				text="Reject Cancellation"
				icon="Inscyth-Cancel"
				visible={order.details.activeARs.includes(AR.PODistributorToApproveCancelation)}
				disabled={rejectCancellation.isLoading}
				onClick={() => setPopupVisibility(true)} >
			</Button>
			<Popup
				title="Reject Cancellation"
				width={600}
				height={450}
				visible={isPopupVisible}
				hideOnOutsideClick={true}
				onHiding={() => setPopupVisibility(false)}
			>
				<ToolbarItem
					options={{
						icon: 'dx-icon dx-icon-close',
						onClick: function () {
							setPopupVisibility(false);
						}
					}}
					widget="dxButton"
					location="after"
				/>
				<div className="release-from-pending-popup-content">
					<Field label={'Rejection Reason'} vertical={true} className="black-label">
						<TextArea ref={reasonRef} height={200} className="required">
							<Validator validationGroup="rejectCancellationValidationGroup">
								<RequiredRule message={'Rejection Reason is required'} />
							</Validator>
						</TextArea>
					</Field>
				</div>
				<ToolbarItem
					options={{
						type: 'normal',
						stylingMode: 'contained',
						text: 'Submit',
						validationGroup: 'rejectCancellationValidationGroup',
						onClick: (e: any) => {
							if (e.validationGroup.validate().isValid) {
								rejectCancellation.mutate(
									reasonRef.current?.instance.option("value")!
								)
							}
						}
					}}
					toolbar={'bottom'}
					widget="dxButton"
					location="after"
				>
				</ToolbarItem>
				<ToolbarItem
					options={{
						type: 'normal',
						stylingMode: 'contained',
						text: 'Cancel',
						onClick: () => setPopupVisibility(false)
					}}
					toolbar={'bottom'}
					widget="dxButton"
					location="after"
				>
				</ToolbarItem>
				<LoadPopupPanel visible={rejectCancellation.isLoading} />
			</Popup>
		</>
	)
}
